// extracted by mini-css-extract-plugin
module.exports = {"firstLine":"Style_firstLine__1Q7SE","shead":"Style_shead__34o-4","sarea":"Style_sarea__2nvqN","sbutt":"Style_sbutt__1QUz_"};